import { ICart } from "./ICart";
export class Cart implements ICart {
    public bookId: number;
    public book_title: string;
    public imageURL: string;
    public currency: string;
    public quantity: number;
    public unitPrice: number;
    public discount: number;
    public discountAmount: number;
    public gst: number;
    public gstAmount: Number;
    public bookType: number;
    public plan: number;
    public classId: number;
    public subjectId: number;
    constructor(
        bookId: number,
        book_title: string,
        imageURL: string,
        currency: string,
        quantity: number,
        unitPrice: number,
        discount: number,
        discountAmount: number,
        gst: number,
        gstAmount: Number,
        bookType: number,
        plan: number,
        classId: number,
        subjectId: number,
    ) {
        this.bookId = bookId;
        this.book_title = book_title;
        this.imageURL = imageURL;
        this.currency = currency;
        this.quantity = quantity;
        this.unitPrice = unitPrice;
        this.discount = discount;
        this.discountAmount = discountAmount;
        this.gst = gst;
        this.gstAmount = gstAmount;
        this.bookType = bookType;
        this.plan = plan;
        this.classId = classId;
        this.subjectId = subjectId;
    }
}